import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  CaretDownOutlined,
  WarningOutlined,
  DownOutlined,
} from "@ant-design/icons";
// import { RangeStepInput } from "react-range-step-input";
// import FileSaver from "file-saver";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DatePicker, Modal } from "antd";
// import { useHistory } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import { toast } from "react-toastify";
import {
  UserAddOutlined,
  UserOutlined,
  EditOutlined,
  DeleteOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import { Card, Space, Slider, Input, Button, Dropdown } from "antd";
import { Select, Table as AntTable, Switch } from "antd";
import Main from "../components/layout/Main";
import edit from "../assets/images/edit.svg";
import Header from "../components/layout/Header";
// import { useCurrentPng } from "recharts-to-png";
import { get, post } from "../Libraries/Ajax/HttpService";
import back from "../assets/images/back.svg";

import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useDistrict } from "../utils/DistrictContext";
function MeterManagement() {
  // let history = useHistory();
  const navigate = useNavigate();
  var mcdata = JSON.parse(localStorage.getItem("MCData"));
  const [optionone, setOptionone] = useState("total");
  const [datas, setDatas] = useState([]);
  const [meterLogList, setMeterlogList] = useState([]);
  const [loading, setloading] = useState(true);
  const [open, setOpen] = useState(false);
  const [accountId, setaccountId] = useState("");
  const [metertId, setmeterId] = useState("");
  const [registerNo, setregisterNo] = useState("");
  const [accountName, setAccountName] = useState("");
  const [metertStatus, setmetertStatus] = useState("");
  const [replacedMeterid, setreplacedMeterid] = useState("");
  const [replacedRegId, setreplacedRegId] = useState("");
  const [isReplaced, setisReplaced] = useState(false);
  const [openConfirm, setopenConfirm] = useState(false);
  const [finalConfirm, setfinalConfirm] = useState(false);
  const [flowStartDate, setflowStartDate] = useState("");
  const [flowEndDate, setflowEndDate] = useState("");
  const [addressLine1, setaddressLine1] = useState("");
  const [addressLine2, setaddressLine2] = useState("");
  const [addressLine3, setaddressLine3] = useState("");
  const [addressCity, setaddressCity] = useState("");
  const [addressDistrict, setaddressDistrict] = useState("");
  const [addressCountry, setaddressCountry] = useState("");
  const [locationId, setlocationId] = useState("");
  const [meterlogId, setmeterLogId] = useState("");
  const [replacedFullmeterid, setreplacedFullmeterid] = useState("");
  const [replacedMeterList, setreplacedMeterLsit] = useState([]);
  const [switchDisable, setSwitchdisable] = useState(false);
  const [meterlistloading, setmeterlistloading] = useState(false);
  const [openRow, setOpenRow] = useState(null);
  const { selectedDistrict } = useDistrict();

  // [
  //     {
  //         "account_id": "139255",
  //         "changed": "New",
  //         "code": "WELL",
  //         "code_name": "Generation Park Well",
  //         "created_at": "Tuesday, May 28, 2024 10:09 AM",
  //         "end_date": "Tuesday, May 28, 2024 05:44 AM",
  //         "first_account_id": "139255",
  //         "first_location_id": "80304",
  //         "first_meter_id": "101893",
  //         "first_register_number": "",
  //         "location_address_line1": "11311 1/2 W LAKE HOUSTON PKWY",
  //         "location_address_line2": "WELL METER",
  //         "location_address_line3": "nan",
  //         "location_city": "HOUSTON",
  //         "location_country": "US",
  //         "location_district": "nan",
  //         "location_id": "80304",
  //         "meter_id": "101893",
  //         "meter_log_id": 1,
  //         "overided_name": "Well",
  //         "register_number": "",
  //         "replaced_account_id": "",
  //         "replaced_location_id": "",
  //         "replaced_meter_id": "",
  //         "replaced_register_number": "",
  //         "start_date": "Tuesday, Jun 25, 2019 01:59 PM"
  //     }
  // ]
  const columns = [
    // {
    //   title: 'Type',
    //   dataIndex: 'type',
    //   key: 'type'
    // },
    // {
    //   title: 'Frequency',
    //   dataIndex: 'frequency',
    //   key: 'frequency'
    // },
    {
      title: "Meter Id",
      dataIndex: "meter_id",
      key: "meter_id",
    },
    {
      title: "Register No",
      dataIndex: "register_number",
      key: "register_number",
    },

    {
      title: "Status",
      dataIndex: "changed",
      key: "unit",
    },
    {
      title: "Account Id",
      dataIndex: "account_id",
      key: "value",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "display_name",
    },
    {
      title: "Account Name",
      dataIndex: "overided_name",
      key: "account_name",
    },
    // {
    //     title: 'Created At',
    //     dataIndex: 'created_at',
    //     key: 'created_at',
    //   },
    //   {
    //     title: 'Location Address Line 1',
    //     dataIndex: 'location_address_line1',
    //     key: 'location_address_line1',

    //   },
    {
      title: "Location City",
      dataIndex: "location_city",
      key: "location_city",
    },
    {
      title: "Location Country",
      dataIndex: "location_country",
      key: "location_country",
    },
    {
      title: "Flow Start Date",
      dataIndex: "start_date",
      key: "start_date",
    },
    {
      title: "Flow End Date",
      dataIndex: "end_date",
      key: "end_date",
    },

    //   {
    //     title: 'Replaced Meter Id',
    //     dataIndex: 'replaced_meter_id',
    //     key: 'replaced_meter_id',

    //   },
    //   {
    //     title: 'Replaced Register No',
    //     dataIndex: 'replaced_register_number',
    //     key: 'replaced_register_number',

    //   },

    {
      title: "Edit",
      dataIndex: "action",
      align: "center",
      key: "id",
      onCell: (record) => {
        return {
          onClick: (ev) => {
            onEditClick(record);
          },
        };
      },
      render: (_, record) => (
        <Space>
          <img
            src={edit}
            alt="Edit"
            style={{ width: "25px", verticalAlign: "middle" }}
          />
        </Space>
      ),
    },
  ];

  // const rows = [
  //     createData('Generation Park', 159, 6.0, 24, 4.0, 3.99),
  //     createData('250 Assay Street', 237, 9.0, 37, 4.3, 4.99),
  //     createData('Lock Wood', 262, 16.0, 24, 6.0, 3.79),
  //     createData('GP Industrial', 305, 3.7, 67, 4.3, 2.5),
  //     createData('Well', 356, 16.0, 49, 3.9, 1.5),
  //   ];

  const handleRowClick = (name) => {
    setOpenRow(openRow === name ? null : name);
  };

  const renderRow = (row, index) => {
    const backgroundColorClass =
      index % 2 === 0 ? "bg-table-blue" : "white-background";
    return (
      <React.Fragment key={row.account}>
        <TableRow
          sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
        >
          {/* <TableCell>
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => handleRowClick(row.name)}
                  > 
                    {openRow === row.name ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </IconButton>
                </TableCell> */}
          <TableCell
            className={backgroundColorClass}
            component="th"
            onClick={() => handleRowClick(row.account)}
            scope="row"
          >
            {row.account}
          </TableCell>
          {/* <TableCell align="right">{row.calories}</TableCell>
                <TableCell align="right">{row.fat}</TableCell> */}
          {/* <TableCell align="right">{row.carbs}</TableCell>
                <TableCell align="right">{row.protein}</TableCell> */}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={openRow === row.account} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Meters
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Meter Id</TableCell>
                      <TableCell>Register No</TableCell>
                      <TableCell>Meter Status</TableCell>
                      <TableCell>Flow Start Time</TableCell>
                      <TableCell>Flow End Time</TableCell>
                      <TableCell>Address</TableCell>
                      {/* <TableCell>Location Id </TableCell>
                            <TableCell align="right">Account Id</TableCell> */}
                      <TableCell align="right">Meter Code</TableCell>
                      <TableCell align="right">Meter Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.meters.map((historyRow) => (
                      <TableRow key={historyRow.created_at}>
                        <TableCell component="th" scope="row">
                          {historyRow.meter_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {historyRow.register_number} 
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {/* {historyRow.changed == "Replaced"? `${historyRow.changed} -(${historyRow.replaced_meter_id},${historyRow.replaced_register_number})`: historyRow.changed == "Old" ? "Active" :`${historyRow.changed}`} */}
                          {historyRow.changed}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {historyRow.start_date}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {historyRow.end_date}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {/* {historyRow.location_address_line1}  */}
                          {[
                            historyRow.location_address_line1,
                            historyRow.location_address_line2,
                            historyRow.location_city,
                            historyRow.location_district,
                            historyRow.location_country,
                          ]
                            .filter(
                              (item) => item && item.toLowerCase() !== "nan"
                            )
                            .join(", ")}
                        </TableCell>
                        {/* <TableCell>{historyRow.location_id} </TableCell>
                              <TableCell align="right">{historyRow.account_id}</TableCell> */}
                        <TableCell align="right">{historyRow.code}</TableCell>
                        <TableCell align="right">
                          {historyRow.code_name}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  useEffect(() => {
    get(`apis/meter_new_list`).then((response) => {
      if (response.status === 200) {
        setTimeout(() => {
          // console.log(response.data);
          setDatas(response.data.data);
        }, 1000);
      }
    });

    get(`apis/account_based_meter_log_list`).then((response) => {
      if (response.status === 200) {
        setTimeout(() => {
          // console.log(response.data);
          setMeterlogList(response.data.data);
        }, 1000);
      }
    });
  }, [selectedDistrict]);

  useEffect(() => {
    if (open) {
      setreplacedMeterLsit(true);
      console.log("meter Log id", meterlogId);
      get(
        `apis/account_based_meter_list?meter_log_id=${meterlogId}&account_id=${accountId}`
      ).then((response) => {
        if (response.status === 200) {
          setmeterlistloading(false);
          setTimeout(() => {
            // console.log(response.data);
            setreplacedMeterLsit(response.data.data);
            if (response.data.data.length == 0) {
              setSwitchdisable(true);
              setisReplaced(false);
            } else {
              setSwitchdisable(false);
            }
            // setreplacedMeterLsit([
            //     {
            //         "meter": "116084,H"
            //     },
            //     {
            //         "meter": "116085"
            //     }s
            // ],)
          }, 1000);
        }
      });
    }
  }, [open,selectedDistrict]);
  // useEffect(() => {
  //       const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //       document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  //     }, []);
  useEffect(() => {
    if (finalConfirm) {
      let data = {};

      if (isReplaced) {
        data = {
          changed: "Replaced",
          meter_id: metertId,
          register_number: registerNo,
          account_id: accountId,
          location_id: locationId,
          meter_log_id: meterlogId,
          replaced_meter_id: replacedMeterid,
          replaced_register_number: replacedRegId,
        };
        console.log(" not empty data is", data);
      } else {
        setregisterNo("");
        setreplacedMeterid("");

        data = {
          changed: "Not Replaced",
          meter_id: metertId,
          register_number: registerNo,
          account_id: accountId,
          location_id: locationId,
          meter_log_id: meterlogId,
          replaced_meter_id: "",
          replaced_register_number: "",
        };
      }

      post("apis/meter_new_list", data).then(
        (response) => {
          setTimeout(() => {
            toast.success(response.data.message);
          }, 1000);

          setTimeout(() => {
            history.go(0);
          }, 2000);
        },
        (error) => {
          toast.error(error.response.data.msg, {
            autoClose: 3000,
          });
        }
      );
    }
  }, [finalConfirm,selectedDistrict]);

  const onEditClick = (record) => {
    setAccountName(record.code_name);
    setmeterId(record.meter_id);
    setregisterNo(record.register_number);
    setmetertStatus(record.changed);
    setaccountId(record.account_id);
    setflowEndDate(record.end_date);
    setflowStartDate(record.start_date);
    setaddressLine1(record.location_address_line1);
    setaddressLine2(record.location_address_line2);
    setaddressLine3(record.location_address_line3);
    setaddressCity(record.location_city);
    setaddressDistrict(record.location_district);
    setaddressCountry(record.location_country);
    setlocationId(record.location_id);
    setmeterLogId(record.meter_log_id);
    setisReplaced(false);
    setreplacedMeterid("");
    setreplacedRegId("");
    setreplacedFullmeterid("");
    setreplacedMeterLsit([]);
    setOpen(true);
    setSwitchdisable(false);

    console.log("record is printed", record.location_city);
    // console.log(override);
  };

  const onclickreplaceddropdown = () => {
    if (replacedMeterList.length == 0) {
      console.log("flase");
      setisReplaced(false);
    }
  };

  const onChangeReplacedfullmeterid = (e) => {
    if (replacedMeterList.length == 0) {
      setisReplaced(false);
    }
    const temp_val = e.target.value.trim(); // Remove any leading/trailing whitespace
    setreplacedFullmeterid(temp_val);
    console.log(temp_val);

    if (temp_val.includes(",")) {
      const [meterId, regId] = temp_val.split(",");
      setreplacedMeterid(meterId.trim()); // Trim any leading/trailing whitespace
      setreplacedRegId(regId.trim());
    } else {
      setreplacedMeterid(temp_val.trim());
      setreplacedRegId(""); // Clear register ID if comma is not present
    }
  };

  const OnchangeReplacedMeterID = (event) => {
    console.log(event.target.value);
    setreplacedMeterid(event.target.value);
  };
  const OnchangeReplacedRegNo = (event) => {
    console.log(event.target.value);
    setreplacedRegId(event.target.value);
  };
  const handleSave = () => {
    if (isReplaced) {
      if (replacedMeterid !== "" || replacedRegId !== "") {
        setopenConfirm(true);
      } else {
        toast.error("Please provide replaced meter details", {
          autoClose: 3000,
        });
      }
    } else {
      setopenConfirm(true);
    }
  };
  const handleCancelConfirm = () => {
    setopenConfirm(false);
  };
  const handleFinalConfirm = () => {
    console.log("final");
    setfinalConfirm(true);
    setopenConfirm(false);
    setOpen(false);
  };

  const onselectClick = () => {
    navigate("/settingsuser");
  };
  const onselectClicks = () => {
    navigate("/list");
  };
  const onselectClickaccount = () => {
    navigate("/accountnames");
  };
  const onselectMetermangement = () => {
    navigate("/metermanagement");
  };

const onselectMeterHistory = () =>{
  navigate('/meterhistory');
}
  const onselectClickss = () => {
    // history.push('/dashboard');
    // window.history.back();
    navigate(-1);
  };
  const handleCancelEdit = () => {
    setOpen(false);
  };
  const onChangeSwitch = (checked) => {
    console.log(`switch to ${checked}`);
    setisReplaced(checked);
  };

  return (
    <>
       {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div>
          <div className="d-flex ">
            <img
              src={back}
              alt=""
              style={{ width: "10px", cursor: "pointer" }}
              onClick={onselectClickss}
            />
            <div className="d-flex align-items-center">
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  <div
                    className="new-box-padding   align-self-center c-pointer"
                    style={{
                      borderBottom: "2px solid #ccc ",
                      borderRadius: "0",
                    }}
                    onClick={onselectClick}
                  >
                    {" "}
                    Settings
                  </div>
                  <div
                    className=""
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                </>
              )}
              
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  
                  <div
                    className="new-box-padding   align-self-center c-pointer "
                    onClick={onselectClicks}
                    style={{
                      borderBottom: "2px solid #ccc",
                    }}
                  >
                    {" "}
                    Users
                  </div>
                </>
              )}

              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding   align-self-center c-pointer "
                onClick={onselectClickaccount}
                style={{
                  borderBottom: "2px solid #ccc",
                }}
              >
                {" "}
                Accounts
              </div>
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  {/* <div
                    className=""
                    onClick={onselectMetermangement}
                    style={{ width: "2px", height: "25px", background: "#1998f0" }}
                  ></div>
                  <div
                    className="new-box-padding text-blue   align-self-center c-pointer  "
                    style={{
                      borderBottom: "2px solid #1998f0",
                    }}
                  >
                    {" "}
                    Meter Management
                  </div> */}
                </>
              )}
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  {/* <div
                    className=""
                    
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                  <div
                    className="new-box-padding   align-self-center c-pointer  "
                    style={{
                      borderBottom: "2px solid #ccc",
                    }}
                    onClick={onselectMeterHistory}
                  >
                    {" "}
                    Meter History
                  </div> */}
                </>
              )}
              
            </div>
          </div>
          <h4 class ="text-blue mt-5 fw-bold mb-4 px-2">New Meters</h4>
          <div className="d-flex align-items-center justify-content-between flex-wrap ">
          
            {/* <br></br> */}

            {/* text-blue  */}

            {datas.length > 0 ? (
              <AntTable
                columns={columns}
                dataSource={datas}
                className="settingsTable mt-4 w-100"
                pagination={true}
              />
            ) : (
              <div className="no-found w-100 text-center">
                <div className="w-100 text-center">
                  <FolderOpenOutlined />
                  <span className="found-text text-center">No New Meter Found</span>
                </div>
              </div>
            )}

            {open === true ? (
              <Modal
                width={800}
                title=""
                open={open}
                onOk={handleSave}
                onCancel={handleCancelEdit}
                centered="true"
                okText="Save"
              >
                <>
                  <div class="row mb-3 d-flex justify-content-between algn-items-center">
                    <div className="col-lg-12 mb-4">
                      <h4 class="text-blue mb-0 fw-bold">
                        Meter {metertId} {""}
                      </h4>
                    </div>

                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Meter Id
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{metertId}</label>
                      </div>
                    </div>
                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Register Number
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{registerNo}</label>
                      </div>
                    </div>

                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Meter Status
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{metertStatus}</label>
                      </div>
                    </div>

                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Account Name
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{accountName}</label>
                      </div>
                    </div>
                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Account Id
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{accountId}</label>
                      </div>
                    </div>
                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Address{" "}
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">
                          {addressLine1},{addressLine2}
                        </label>
                      </div>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">
                          {" "}
                          {[addressCity, addressDistrict, addressCountry]
                            .filter(
                              (item) => item && item.toLowerCase() !== "nan"
                            )
                            .join(", ")}
                        </label>
                      </div>
                    </div>

                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Location Id
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{locationId}</label>
                      </div>
                    </div>

                   
                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Flow Start Date
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{flowStartDate}</label>
                      </div>
                    </div>

                    <div class="col-md-6 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Flow End Date
                      </h6>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{flowEndDate}</label>
                      </div>
                    </div>

                    <hr className="mt-3" />
                    <div class="col-md-12 mt-1">
                      <h6 className="w-100  total-flow-font-size included-outliers bg-gray">
                        Confirm Meter Status
                      </h6>
                      <br></br>
                      <div class="form-check ps-0 ">
                        <label className="ms-3">{" New Meter"} </label>{" "}
                        <Switch
                          checked={isReplaced}
                          disabled={switchDisable}
                          onChange={onChangeSwitch}
                        />{" "}
                        <label className="ms-3">{"Replaced Meter"}</label>
                      </div>
                      <br></br>
                      
                    </div>

                    {isReplaced === true && replacedMeterList.length > 0 ? (
                      <>
                        {" "}
                        <hr />
                        <div className="col-md-6 mt-1">
                          <h6 className="w-100 total-flow-font-size included-outliers bg-gray">
                            Replaced Meter Id
                          </h6>
                          <select
                            name="All meters"
                            id="selector"
                            value={replacedFullmeterid}
                            className="box w-100"
                            onChange={onChangeReplacedfullmeterid}
                          >
                            <option value="" disabled>
                              Select Replaced Meter
                            </option>

                            {replacedMeterList.map((item, index) => (
                              <option key={index} value={item.meter}>
                                {item.meter}
                              </option>
                            ))}
                          </select>
                        </div>
                      </>
                    ) : meterlistloading ? (
                      <></>
                    ) : replacedMeterList && replacedMeterList.length === 0 ? (
                      <h6 className="w-100 total-flow-font-size included-outliers bg-gray">
                        {" "}
                        Replace option not available .{" "}
                      </h6>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              </Modal>
            ) : (
              ""
            )}

            {openConfirm && open ? (
              <Modal
                width={900}
                title=""
                open={openConfirm}
                onOk={handleFinalConfirm}
                onCancel={handleCancelConfirm}
                centered="true"
                okText="Confirm"
              >
                <>
                  <div class="row mb-3 d-flex justify-content-between algn-items-center">
                    <div className="col-lg-12 mb-4">
                      
                      <h6 class="text-blue mb-0 fw-bold">
                        Confirm save: Are you sure you want to proceed?
                      </h6>
                    </div>
                  </div>
                </>
              </Modal>
            ) : (
              ""
            )}
            
           <div className="w-100">
            <h4 class="text-blue mb-0 fw-bold mb-4 px-2">Account-Wise Meter Log</h4>
            
            {meterLogList.length > 0 ? (
              <div style={{background: '#fff', padding: '12px 10px', borderRadius: '15px'}}>
                <TableContainer component={Paper} className="">
                  <Table aria-label="collapsible table">
        
                    <TableBody>
                      {meterLogList.map((row, index) => renderRow(row, index))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            ) : (
              <div className="no-found w-100 text-center">
                <div className="w-100 text-center">
                  <FolderOpenOutlined />
                  <span className="found-text text-center">No data Found</span>
                </div>
              </div>
            )}
           </div>
          </div>
        </div>
      </Main>
    </>
  );
}

export default MeterManagement;
